import React from "react";
import PremiumGameLoader from "./PremiumGameLoader";

export default function Loading({ gameName = "Casino" }) {
  return <PremiumGameLoader gameName={gameName} />;
}
